import { ClientEffects } from './client.effects';
import { EmployeeEffects } from './employee.effects';
import { VehicleEffects } from './vehicle.effects';
import { NoteEffects } from './note.effects';
import { UserProfileEffects } from './user-profile.effects';

export const mainEffects = [
  EmployeeEffects,
  VehicleEffects,
  ClientEffects,
  NoteEffects,
  UserProfileEffects
];